export class Stop {
    coordinate!: number;
    action!: () => unknown;
}
